import { ModuleModel } from '../../module.model.interface';
import { ProfileModel } from '../../profile/model/profile.model';

export class NotificationDescriptor implements ModuleModel {
  public discriminator = 'NotificationDescriptor';

  public id: string;
  public profileId: string;
  public title: string;
  public percentComplete: number;
  public hasManifest: boolean;
  public reference: string;
  public errorMessage: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public profileDetail?: ProfileModel;
  public profileFullName?: string;

  constructor(options?: {
    id: string;

    profileId: string;
    title: string;
    percentComplete: number;
    hasManifest: boolean;
    reference: string;
    errorMessage: string;
  
    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;

      this.profileId = options.profileId;
      this.title = options.title;
      this.percentComplete = options.percentComplete;
      this.hasManifest = options.hasManifest;
      this.reference = options.reference;
      this.errorMessage = options.errorMessage;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/notification/model/notification.ts